import { faInfoCircle } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function InfoCallout({ children }) {
  return (
    <div className="flex flex-row gap2 bg-indigo-50 dark:bg-indigo-500/20 p-3 rounded-xl my-2 text-indigo-500 dark:text-indigo-300">
      <FontAwesomeIcon icon={faInfoCircle} className="mr-2" />
      <span className="text-sm">{children}</span>
    </div>
  );
}
